import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetaForPath, getStructuredData } from '../content/seo';

function setMeta(selector, attr, value) {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attr, value);
}

export function Seo() {
  const location = useLocation();

  useEffect(() => {
    const meta = getMetaForPath(location.pathname);
    document.title = meta.title;
    setMeta('meta[name="description"]', 'content', meta.description);
    setMeta('meta[name="robots"]', 'content', meta.noindex ? 'noindex,follow' : 'index,follow,max-image-preview:large');
    setMeta('meta[property="og:title"]', 'content', meta.title);
    setMeta('meta[property="og:description"]', 'content', meta.description);
    setMeta('meta[property="og:image"]', 'content', meta.image);
    setMeta('meta[property="og:type"]', 'content', meta.ogType);
    setMeta('meta[property="og:url"]', 'content', meta.canonical);
    setMeta('meta[name="twitter:title"]', 'content', meta.title);
    setMeta('meta[name="twitter:description"]', 'content', meta.description);
    setMeta('meta[name="twitter:image"]', 'content', meta.image);
    setMeta('link[rel="canonical"]', 'href', meta.canonical);

    let schema = document.head.querySelector('#page-schema');
    if (!schema) {
      schema = document.createElement('script');
      schema.id = 'page-schema';
      schema.type = 'application/ld+json';
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify(getStructuredData(meta));
  }, [location.pathname]);

  return null;
}
